import { IRecipeBook } from "../../types/recipe";
import { getApi } from "../api";
import { RecipeBookDb } from "../indexeddb/recipeBookDb";
import { getStringFromLocalStorage } from "../localStorage";

const apiUrl = import.meta.env.VITE_API_URL as string;
const apiToken = getStringFromLocalStorage("idToken");

export class RecipeBookStore {
  private static instance: RecipeBookStore | null = null;
  private _readyPromise: Promise<void>;
  private db = new RecipeBookDb();
  public recipe_books: IRecipeBook[] = [];
  private constructor() {
    this._readyPromise = this.load();
  }

  public static getInstance(): RecipeBookStore {
    if (!RecipeBookStore.instance) {
      RecipeBookStore.instance = new RecipeBookStore();
    }
    return RecipeBookStore.instance;
  }

  public ready(): Promise<void> {
    return this._readyPromise;
  }

  private async load(): Promise<void> {
    await this.db.initDB();
    await this.getRecipeBooks();
  }

  public async getRecipeBooks(clear: boolean = false): Promise<void> {
    try {
      const local = await this.db.getRecipeBooks();
      if (local.length === 0 || clear) {
        const api = await getApi(apiUrl, "recipebook", apiToken);
        await this.db.addRecipeBooks(api, clear);
        this.recipe_books = api;
      } else {
        this.recipe_books = local;
      }
    } catch (e: any) {
      console.log(e);
    }
  }
}
